import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  const whatsappNumber = '595986586920';
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">{t('whatsapp.chat')}</span>
    </a>
  );
};
